import { useI18next } from "@bond-london/gatsby-plugin-cms-i18next";
import { navigate } from "gatsby";
import React, { useCallback } from "react";
import { Trans } from "react-i18next";
import { NorwegianFlag } from "../icons/NorwegianFlag";
import { UKFlag } from "../icons/UKFlag";

const flags: Record<string, React.FC<{ className?: string }>> = {
  en: UKFlag,
  nb: NorwegianFlag,
};
export const LanguageChooser: React.FC<{
  corePath: string;
  onClick?: () => void;
}> = ({ corePath, onClick }) => {
  const { currentLanguage, languages } = useI18next();
  const handleLanguageChange = useCallback(
    (lng: string) => {
      onClick?.();
      void navigate(`/${lng}${corePath}`);
    },
    [corePath, onClick],
  );

  return (
    <div className="mt-10px flex flex-col gap-y-10px">
      <h3 className="h7 text-lazer">
        <Trans>Switch Language</Trans>
      </h3>
      <div className="flex gap-x-10px text-cotton">
        {languages
          .filter((l) => l !== currentLanguage)
          .map((l) => {
            const Flag = flags[l];
            return (
              <button
                key={l}
                onClick={() => handleLanguageChange(l)}
                className="flex items-center gap-x-16px"
              >
                <Trans>{l}</Trans>
                <Flag className="h-[2em]" />
              </button>
            );
          })}
      </div>
    </div>
  );
};
